export default __webpack_public_path__ + "static/media/i244hp.b9b13129.webp";